export default __webpack_public_path__ + "static/media/markdown.6512d546.svg";